// Local development hosts
export const LOCAL_HOSTS = {
  host: 'http://localhost.fleet.com.au:8180',
  socketHost: 'ws://localdocker.fleet.com.au:8380/socket',
  socketTopicPrefix: '/topic/local/core/v3/',
  socketAcknowledge:
    'http://localhost.fleet.com.au:8380/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'http://localhost.fleet.com.au:8480/tas/api/local/v1',
};

// AU1 Production hosts
export const AU1_PRODUCTION_HOSTS = {
  host: 'https://production-tapi-live.au1.fleet.com.au',
  socketHost: 'wss://production-svc-socket.au1.fleet.com.au/socket',
  socketTopicPrefix: '/topic/live/core/v3/',
  socketAcknowledge:
    'https://production-svc-socket.au1.fleet.com.au/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://production-svc-tas.au1.fleet.com.au/tas/api/live/v1',
};

// US1 Production hosts (uses legacy socket)
export const US1_PRODUCTION_HOSTS = {
  host: 'https://production-tapi-live.us1.fleet.com.au',
  socketHost: 'wss://production-svc-socket.us1.fleet.com.au/socket',
  socketTopicPrefix: '/topic/live/core/v3/',
  socketAcknowledge:
    'https://production-svc-socket.us1.fleet.com.au/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://production-svc-tas.us1.fleet.com.au/tas/api/live/v1',
};

// AU1 Staging hosts
export const AU1_STAGING_HOSTS = {
  host: 'https://preprod-tapi-staging.au1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.au1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/staging/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.au1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.au1.fleet-dev.com/tas/api/staging/v1',
};

// US1 Staging hosts
export const US1_STAGING_HOSTS = {
  host: 'https://preprod-tapi-staging.us1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.us1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/staging/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.us1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.us1.fleet-dev.com/tas/api/staging/v1',
};

// AU1 Test1 hosts
export const AU1_TEST1_HOSTS = {
  host: 'https://preprod-tapi-test1.au1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.au1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/test1/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.au1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.au1.fleet-dev.com/tas/api/test1/v1',
};

// US1 Test1 hosts
export const US1_TEST1_HOSTS = {
  host: 'https://preprod-tapi-test1.us1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.us1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/test1/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.us1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.us1.fleet-dev.com/tas/api/test1/v1',
};

// US1 Test2 hosts
export const US1_TEST2_HOSTS = {
  host: 'https://preprod-tapi-test2.us1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.us1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/test2/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.us1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.us1.fleet-dev.com/tas/api/test2/v1',
};

// AU1 Demo1 hosts
export const AU1_DEMO1_HOSTS = {
  host: 'https://preprod-tapi-demo1.au1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.au1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/demo1/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.au1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.au1.fleet-dev.com/tas/api/demo1/v1',
};

// US1 Demo1 hosts
export const US1_DEMO1_HOSTS = {
  host: 'https://preprod-tapi-demo1.us1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.us1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/demo1/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.us1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.us1.fleet-dev.com',
};

// US1 Bugfix hosts
export const US1_BUGFIX_HOSTS = {
  host: 'https://preprod-tapi-bugfix.us1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.us1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/bugfix/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.us1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.us1.fleet-dev.com/tas/api/bugfix/v1',
};

// AU1 Bugfix hosts
export const AU1_BUGFIX_HOSTS = {
  host: 'https://preprod-tapi-bugfix.au1.fleet-dev.com',
  socketHost: 'wss://preprod-svc-socket.au1.fleet-dev.com/socket',
  socketTopicPrefix: '/topic/bugfix/core/v3/',
  socketAcknowledge:
    'https://preprod-svc-socket.au1.fleet-dev.com/socket/client/{{clientId}}/acknowledge/',
  tasHost: 'https://preprod-svc-tas.au1.fleet-dev.com/tas/api/bugfix/v1',
};
